import React from 'react';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';

const RadioInputContainer = styled.div`
  align-items: center;
  border: ${props => props.isChecked ? 'solid 3px ' + "#243991" : 'solid 1px ' + colorGrid.gray3};
  background-color: ${colorGrid.gray0};
  border-radius: 100%;
  display: flex;
  height: ${props => props.isChecked ? '22px' : '24px'};
  justify-content: center;
  width: ${props => props.isChecked ? '22px' : '24px'};
`;

const StyledRadioInput = styled.div`
  background-color: ${props => props.isChecked ? "#243991" : colorGrid.gray0};
  border-radius: 100%;
  cursor: pointer;
  height: 12px;
  outline: 0;
  position: relative;
  width: 12px;
`;

const StyledInput = styled.input`
  position: absolute;
  visibility: hidden;
`;

const RadioInput = (props) => {
  const toggleCheckBox = (e) => {
    e.preventDefault(); //This is needed to ensure that the Radio Area is Triggering the event properly
    props.cbChanged && props.cbChanged(props.value);
  };

  const handleKeyDownMenu = (e) => {
    switch (e.keyCode) {
      case 32: //spacebar
        toggleCheckBox(e);
        break;
      case 13: //enter
        toggleCheckBox(e);
        break;
      default:
      // do nothing
    }
  };

  return (
    <RadioInputContainer
      className="radioInputContainer"
      aria-label="radioInput"
      isChecked={props.isChecked}
    >
      <StyledRadioInput
        aria-label="radioInput"
        className="radioInputCustom"
        isChecked={props.isChecked}
        onClick={toggleCheckBox}
        onKeyDown={handleKeyDownMenu}
        tabIndex="0"
      >
        <StyledInput
          aria-label="radio"
          className="radio"
          type="radio"
          defaultChecked={props.isChecked}
          tabIndex="0"
          name={props.name}
          value={props.value}
        />
      </StyledRadioInput>
    </RadioInputContainer>
  );
};

RadioInput.propTypes = {
  cbChanged: PropTypes.func,
  isChecked: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string
};

RadioInput.defaultProps = {
  cbChanged: () => { },
  isChecked: false,
  name: 'radioInput',
  value: 'radioInput'
};
export default RadioInput;
